import Auth from '@/Auth.js';
import { podeAcessarRadarExecucao } from '@/modules/radar-execucao/utils/acessoRadar.mjs';
import { podeAcessarRelatoriosCiclo } from '@/modules/selo-fechamento/relatoriosCiclo.mjs';
import { atualUfDefinition } from '@/helpers/utils';

export default (to, from, next) => {
  Auth.setItem('last_route', from.path)

  if (to.matched.some(record => record.meta.requiresRelatoriosCiclo) && Auth.isLogged()) {
    if (!podeAcessarRelatoriosCiclo(Auth.getItem('config'), Auth.getItem('groupsConfig'), Auth.getItem('user'), atualUfDefinition.banco)) {
      return next({ path: '/cidade' })
    }
  }

  if (to.matched.some(record => record.meta.requiresRadarExecucao) && Auth.isLogged()) {
    const user = Auth.getItem('user')
    const fullAdmin = user && String(user.email || '').trim().toLowerCase() === 'admin@admin.com.br'
    if (!podeAcessarRadarExecucao(Auth.getItem('config'), Auth.getItem('groupsConfig'), fullAdmin)) {
      return next({ path: '/cidade' })
    }
  }

  if (to.matched.some(record => record.meta.requiresSeloFechamento) && Auth.isLogged()) {
    const user = Auth.getItem('user')
    const config = Auth.getItem('config')
    const groupsConfig = Auth.getItem('groupsConfig')
    const fullAdmin = user && String(user.email || '').toLowerCase() === 'admin@admin.com.br'
    if (!(config && config.fechamentoSelo && (fullAdmin || (groupsConfig && groupsConfig.fechamentoSelo)))) {
      return next({ path: '/cidade' })
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Auth.isLogged()) {
      return next({
        path: '/auth/login'
      })
    }
  }

  if (to.matched.some(record => record.meta.requiresFullAdmin)) {
    const user = JSON.parse(localStorage.getItem('user'))
    if (!user || user.email !== 'admin@admin.com.br') {
      return next({
        path: '/cidade'
      })
    }
  }

  if (to.matched.some(record => record.meta.requiresNoAuth)) {
    if (Auth.isLogged()) {
      return next({
        path: '/cidade'
      })
    }
  }
  if (to.matched.some(record => record.meta.verifyVisibleRelatorio)) {
    const user = JSON.parse(localStorage.getItem("user"))
    const relatorioAdm = JSON.parse(user.grupo.relatorioAdm) || [];

    if (relatorioAdm.filter(item => item == to.params.relatorioRoute).length === 0 && user.email !== "admin@admin.com.br") {
      return next({
        path: '/cidade'
      })
    }
  }
  next()
}
